import React from 'react';
import { ContentItem } from '../../../models/ContentManagementInterface';

export const AUTOSAVE_DELAY_MS = 2000;

export const fieldLabelStyle: React.CSSProperties = {
  fontSize: '12px',
  color: '#888',
  marginBottom: '4px',
};

export const sectionLabelStyle: React.CSSProperties = {
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  color: '#666',
  marginBottom: '4px',
};

export const BLOCK_TYPE_LABELS: Record<string, string> = {
  StandardHeaderText: 'Text Section',
  Subtitle: 'Subtitle',
  Text: 'Text',
  LeftRightList: 'Key Details List',
  ImageCarousel: 'Image Cards',
  HeroImage: 'Hero Image',
  Table: 'Table',
};

export const ADD_BLOCK_OPTIONS: Array<{ type: ContentItem['type']; label: string }> = [
  { type: 'StandardHeaderText', label: 'Text Section' },
  { type: 'Subtitle', label: 'Subtitle' },
  { type: 'Text', label: 'Text' },
  { type: 'LeftRightList', label: 'Key Details List' },
  { type: 'ImageCarousel', label: 'Image Cards' },
  { type: 'HeroImage', label: 'Hero Image' },
  { type: 'Table', label: 'Table' },
];
